<template>
  <form novalidate @submit.prevent="() => {}">
    <v-row no-gutters>
      <v-col cols="8">
        <v-card max-width="1200px" flat color="transparent">
          <v-card-title>
            <FormHeader
              :loading="loading"
              :link="'page-seo-configs'"
              :title="
                data.name ? `${data.name} конфигурация seo` : `Создать конфигурацию seo`
              "
            />
          </v-card-title>
          <v-card-text>
            <PageContent height="85">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <span>Имя * (<TranslationIcon />)</span>
                    <v-text-field
                    id="name"
                      outlined
                      :disabled="loading"
                      :error-messages="validationErrors.name"
                      v-model="fields.name"
                    />
                  </v-col>
                  <v-col cols="12">
                    <span>Ключ *</span>
                    <v-text-field
                    id="key"
                      outlined
                      :disabled="loading"
                      :error-messages="validationErrors.key"
                      v-model="fields.key"
                    />
                  </v-col>
                  <v-col cols="12">
                    <span>Meta title (<TranslationIcon />)</span>
                    <v-text-field
                      outlined
                      :disabled="loading"
                      v-model="fields.seoMetaTitle"
                    />
                  </v-col>
                  <v-col cols="12">
                    <span>Description (<TranslationIcon />)</span>
                    <v-text-field
                      outlined
                      :disabled="loading"
                      v-model="fields.seoMetaDescription"
                    />
                  </v-col>
                  <v-col cols="12">
                    <span>Keywords (<TranslationIcon />)</span>
                    <v-text-field
                      outlined
                      :disabled="loading"
                      v-model="fields.seoMetaKeywords"
                    />
                  </v-col>
                  <v-col cols="12">
                    <span>SEO disallow index</span>
                    <v-switch
                      inset
                      dense
                      :disabled="loading"
                      :loading="loading"
                      v-model="fields.seoDisallowIndex"
                    />
                  </v-col>
                  <v-col cols="12">
                    <span>Rel canonical</span>
                    <v-text-field
                      outlined
                      :disabled="loading"
                      v-model="fields.seoRelCanonical"
                    />
                  </v-col>
                  <v-col cols="12">
                    <span>SEO image</span>
                    <MediaFilePicker
                      :multiple="false"
                      :file-type="$options.mediaTypesByKeys.IMAGE"
                      :value="fields.seoOgImageId"
                      @change="fields.seoOgImageId = $event"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </PageContent>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <ManageSidePanel
          ref="manageSidePanel"
          :is-new="!data.id"
          :created-at="data.createdAt"
          :updated-at="data.updatedAt"
          :is-loading="loading"
          :language="language"
          :translations="fields.translations"
          @submit="submit"
          @delete="$emit('delete-seo-config')"
          @cancel="$router.push({ name: 'page-seo-configs' })"
          @update-translations="Object.assign(fields.translations, $event)"
          @language-update="$emit('language-update', $event)"
        >
        </ManageSidePanel>
      </v-col>
    </v-row>
  </form>
</template>
<script>
import FormAbstract from '@/components/abstract/form'
import ManageSidePanel from '@/components/manage-side-panel'
import validationRules from './validation-rules.js'
import MediaFilePicker from '@/components/media-file-picker'
import TranslationIcon from '@/components/translation-icon/translationIcon'
import validationTranslations from '@/mixins/translations/validationTranslations.mix.js'
import prepareTranslations from '@/mixins/translations/prepareTranslations.mix'
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'
import FormHeader from '@/components/form-header'
import PageContent from '@/components/page-content/PageContent.vue'

export default {
  extends: FormAbstract,
  mediaTypesByKeys: mediaTypesByKeys(),
  name: 'FormPage',
  validationRules,
  mixins: [validationTranslations, prepareTranslations],
  components: {
    PageContent,
    TranslationIcon,
    ManageSidePanel,
    MediaFilePicker,
    FormHeader
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    isNew: {
      type: Boolean,
      default: true
    },
    language: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      fields: {
        name: null,
        key: null,
        seoMetaTitle: null,
        seoMetaDescription: null,
        seoDisallowIndex: false,
        seoMetaKeywords: null,
        seoRelCanonical: null,
        seoOgImageId: null,
        translations: { ru: { isEnabled: true } }
      }
    }
  },
  watch: {
    data (data) {
      this.populate(data)
      this.fields.seoOgImageId = data?.seoOgImage?.id || null
    }
  },
  methods: {
    async submit () {
      const isValid = await this.validate()
      if (!isValid) {
        this.mixScrollToError(this.$v)
        return
      }
      if (!this.mixIsValidTranslations(this.fields.translations)) {
        this.$errorMsg('Не выбран ни один язык для контента!')
        return
      }
      const payload = {
        ...this.composeFormData(this.fields)
      }
      this.mixPrepareTranslations(payload)
      this.$emit('submit', { data: payload })
    }
  }
}
</script>
